//import { List, Datagrid, TextField, EmailField } from "react-admin";
import { SimpleList, SelectColumnsButton, Datagrid, TextField, EmailField, UrlField, EditButton, TopToolbar } from "react-admin";
import { Edit, Create, DatagridConfigurable, DateField, SimpleForm, ReferenceInput, TextInput, ReferenceField, SelectInput} from "react-admin";
import { BulkDeleteButton, DeleteButton, BulkExportButton } from 'react-admin';
import { Fragment,useRef } from 'react';
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { MyEmailField,MyEmptyDateField } from "./MyUrlField";
import { useNotify, useRefresh, useRedirect, useDataProvider} from 'react-admin';
import { DateInput, Toolbar, SaveButton } from 'react-admin';
import { ImportButton } from "react-admin-import-csv";
import { CreateButton, FilterButton, ExportButton } from "ra-ui-materialui";
import { Chip }  from '@mui/material';
import { List, downloadCSV, required } from 'react-admin';
import jsonExport from 'jsonexport/dist';
import { useTranslate } from 'react-admin';
import React, { useState } from 'react';
import { useGetOne,useGetMany,useGetManyReference } from 'react-admin';
import { Box, Typography, FormControl, FormLabel,RadioGroup,FormControlLabel,Radio } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { FunctionField } from "react-admin";
import { Tooltip } from "@mui/material";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import moment from "moment";


const getTime=() =>{
  const now = new Date();
  const formattedDate = now.toLocaleString('it-IT', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
  }).replace(/\//g, '-').replace(',', ''); 
  const parts = formattedDate.split(' ');
  const finalDate = `${parts[0].split('-').reverse().join('-')} ${parts[1]}`;
  return finalDate;
}

const exportToXLS = async (records, fetchRelatedRecords) => {
  if (!records || records.length === 0) return;
  
  const bambiniMap = await fetchRelatedRecords(records, "id_bambino", "bambini");

  const exportedRecords = records.map(record => ({
    "Identificativo": record.id,
    Bambino: bambiniMap[record.id_bambino]
      ? `${bambiniMap[record.id_bambino].nome} ${bambiniMap[record.id_bambino].cognome} - ${bambiniMap[record.id_bambino].codice_fiscale}`
      : "N/A",
    "Nome": record.nome,
    "Cognome": record.cognome,    
    "Telefono": record.telefono,
    "Assicutazione": record.assicurazione,
    "Data di inserimento": record.timestamp_inserimento    
  }));
  const worksheet = XLSX.utils.json_to_sheet(exportedRecords);
  const colWidths = Object.keys(exportedRecords[0] || {}).map(key => ({
    wch: Math.max(
      key.length, 
      ...exportedRecords.map(record => (record[key] ? record[key].toString().length : 0))
    )
  }));
  worksheet["!cols"] = colWidths;
  
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Dati");  
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  saveAs(data, "accompagnatori.xlsx");
};


const AccompagnatoreBulkActionButtons = () => (
  <Fragment>
      <BulkExportButton maxResults= {15000} exporter={exportToXLS}  />               
      
      <BulkDeleteButton mutationMode="pessimistic"/>
  </Fragment>
);


const AccompagnatoreFilters = [
  <TextInput label="Cerca" source="q" alwaysOn />,
  <ReferenceInput source="id_bambino" reference="bambini" label="Bambino" perPage={1000} sort={{ field: 'nome', order: 'ASC' }}>
      <SelectInput optionText={(record) => `${record.nome} ${record.cognome} (${record.codice_fiscale})`} />
  </ReferenceInput> ,  
];


const AccompagnatoreActions = (props) => {
  const {
    className,
    basePath,    
    resource,
    currentSort,
    filterValues,
    exporter,
  } = props;
  return (
    <TopToolbar className={className}>
      <SelectColumnsButton />            
      <FilterButton/>
      <CreateButton basePath={basePath} />
      <ExportButton         
        resource={resource}
        sort={currentSort}
        filter={filterValues}        
        exporter={exporter}
        maxResults= {15000}   
      />        
    </TopToolbar>
  );
};


export const AccompagnatoreList = (props) => (
  <List {...props} sort={{ field: 'id', order: 'ASC' }} filters={AccompagnatoreFilters} perPage={50} actions={<AccompagnatoreActions exporter={exportToXLS}/>}>    
    <DatagridConfigurable  bulkActionButtons={<AccompagnatoreBulkActionButtons />}>   
        <TextField sortable={false} source="id" />
        <ReferenceField sortable={false} source="id_bambino" reference="bambini" label="Bambino">
            <TextField  source="nome" /> <TextField source="cognome" /> - <TextField source="codice_fiscale" />
        </ReferenceField>        
        <TextField sortable={false} source="cognome" label="Cognome" />          
        <TextField sortable={false} source="nome" label="Nome"/>
        <TextField sortable={false} source="telefono" label="Telefono" />        
        <TextField sortable={false} source="assicurazione" label="Assicurazione"/>                     
        <EditButton/>
    </DatagridConfigurable>
  </List>
);


export const AccompagnatoreEdit = () => {
  //const [localTitolo, setLocalTitolo] = useState({});
  const { id } = useParams();
  //const { data: titolo, isPending, error } = useGetOne('accompagnatori', { id: id });    
  const notify = useNotify();      
  const redirect = useRedirect();
  const refresh = useRefresh(); 
  const dataProvider = useDataProvider();  
  
  

  const handleEdit = async (values) => {
    try {
      var data2=transform2(values);
      console.log("Editing",values,data2);
      console.log(data2.id, values.id);
      const { data } = await dataProvider.update('accompagnatori', { id:data2.id, data: data2 });          
      console.log('Resource updated successfully:', data, values);          
      notify("Dati aggiornati con successo!", { messageArgs: { smart_count: 1 } });
      refresh();
      redirect('/accompagnatori');                  
    } catch (error) {      
      notify("Qualcosa è andato storto nella modifica dell'accompagnatore. Riprovare più tardi");
    }
  };

  return(        
    <Edit title={<username />} mutationMode="pessimistic" transform={transform2}>     
      <SimpleForm onSubmit={handleEdit} sx={{ maxWidth: '100%' }}>   
      <Box display={{ xs: 'block', sm: 'flex', width: '100%' }}>
        <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
            <ReferenceInput source="id_bambino" reference="bambini"  perPage={1000}>                     
                <SelectInput label="Bambino"  option="nome" optionText={(record) => `${record.nome} ${record.cognome} - ${record.codice_fiscale}`}    options={{fullWidth:true}} sx={{textAlign: "left"}} fullWidth  validate={required()} disabled={true}/>
            </ReferenceInput>
        </Box>
        <Box flex={1} ml={{ xs: 0, sm: '0.5em' }}>           
        </Box>
    </Box>

    <Box display={{ xs: 'block', sm: 'flex', width: '100%' }}>
        <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
        <TextInput source="cognome" label="Cognome" fullWidth validate={required()}/>    
        </Box>
        <Box flex={1} ml={{ xs: 0, sm: '0.5em' }}>           
        <TextInput source="nome" label="Nome" fullWidth validate={required()}/>    
        </Box>
    </Box>

    <Box display={{ xs: 'block', sm: 'flex', width: '100%' }}>
        <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
        <TextInput source="telefono" label="Telefono" fullWidth validate={required()}/>    
        </Box>
        <Box flex={1} ml={{ xs: 0, sm: '0.5em' }}>           
        <TextInput source="assicurazione" label="Assicurazione" fullWidth />    
        </Box>
    </Box>   
  
      </SimpleForm>
    </Edit>
    )
};



const transform2 = (data) => {
  const sanitizedData = {};
  for (const key in data) {   
      sanitizedData[key] = data[key]; 
  }
  sanitizedData["timestamp_inserimento"]=getTime();
  
  return sanitizedData; 
};




export const AccompagnatoreCreate =  ({ onSuccess, ...props }) => { 
  const notify = useNotify();    
  const redirect = useRedirect();
  const dataProvider = useDataProvider();
  const [selectedValue, setSelectedValue] = useState("abbonamento");
  
  const handleCreate = async (values) => {
    try {
      var data2=transform2(values);
      const { data } = await dataProvider.create('accompagnatori', { data: data2 });        
      // Custom logic after successful creation
      console.log('Resource created successfully:', data, values);
      
      notify("Accompagnatore registrato correttamente!", { messageArgs: { smart_count: 1 } });
      redirect('/accompagnatori');        
    } catch (error) {
      notify("Qualcosa è andato storto nella creazione dell'accompagnatore. Riprovare più tardi");
    }
  };   
  return(

    <Create transform={transform2}  {...props} >           
    <SimpleForm onSubmit={handleCreate} sx={{ maxWidth: '100%' }}> 
    
    <Box display={{ xs: 'block', sm: 'flex', width: '100%' }}>
        <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
            <ReferenceInput source="id_bambino" reference="bambini"  perPage={1000} sort={{ field: 'nome', order: 'ASC' }}>                     
                <SelectInput label="Bambino"  option="nome" optionText={(record) => `${record.nome} ${record.cognome} - ${record.codice_fiscale}`}    options={{fullWidth:true}} sx={{textAlign: "left"}} fullWidth  validate={required()}/>
            </ReferenceInput>
        </Box>
        <Box flex={1} ml={{ xs: 0, sm: '0.5em' }}>           
        </Box>
    </Box>

    <Box display={{ xs: 'block', sm: 'flex', width: '100%' }}>
        <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
        <TextInput source="cognome" label="Cognome" fullWidth validate={required()}/>    
        </Box>
        <Box flex={1} ml={{ xs: 0, sm: '0.5em' }}>           
        <TextInput source="nome" label="Nome" fullWidth validate={required()}/>    
        </Box>
    </Box>

    <Box display={{ xs: 'block', sm: 'flex', width: '100%' }}>
        <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
        <TextInput source="telefono" label="Telefono" fullWidth validate={required()}/>    
        </Box>
        <Box flex={1} ml={{ xs: 0, sm: '0.5em' }}>           
        <TextInput source="assicurazione" label="Assicurazione" fullWidth />    
        </Box>
    </Box>
        
    </SimpleForm>
    </Create> 
  );
}
